import React, { useState } from 'react'
import { Helmet } from 'react-helmet';
import utils from '../../utils';
import AuthSidebar from '../../components/auth/AuthSideBar';
import OrdersTab from '../../components/dashboard/OrdersTab';
import RefundsTabs from '../../components/orders/RefundsTabs';

function OrdersPage() {
    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        "Orders",
        "Refunds"
    ];
    return (
        <main className="container mx-auto px-6 py-4">
            <Helmet>
                <title>My Orders - {utils.siteName}</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className="flex flex-col md:flex-row gap-8 lg:gap-12">
                <AuthSidebar />
                <div className="flex-1">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6">
                        <div>
                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
                                Orders
                            </h1>
                            <p className="text-gray-500 dark:text-gray-400 mt-1">
                                Your orders and refund requests.
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-center mb-6">
                        <div className=" border-gray-200 dark:border-border-dark">
                            <div className="tabs tabs-boxed justify-center">
                                {tabs.map((tab, idx) => (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a
                                        key={idx}
                                        className={`tab ${activeTab === idx ? 'tab-active bg-primary text-white rounded-lg' : ''}`}
                                        onClick={() => setActiveTab(idx)}
                                        role="tab"
                                        aria-selected={activeTab === idx}
                                    >
                                        {tab}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                    {activeTab === 0 && (
                        <OrdersTab />
                    )}
                    {activeTab === 1 && (
                        <RefundsTabs />
                    )}
                </div>
            </div>
        </main>
    )
}

export default OrdersPage